import styled from 'styled-components'
import { LoadingButton } from '@mui/lab';
import { ErrorOutline as ErrorOutlineIcon } from '@mui/icons-material';
import { alpha, styled as muiStyled } from '@mui/material/styles';
import { FormControl, TextField, Input, Button, InputBase, NativeSelect, Select, OutlinedInput, ButtonGroup, Fab, Autocomplete, ListItem, List, Paper, Tooltip, tooltipClasses, Box, textFieldClasses, Badge } from '@mui/material'
import { dark, ligthGray, error, gTheme, thirdly2, gray, light, lightBlue, lightBlue2, mandatory, primary, rating1, rating2, rating4, secondary, white, text, thirdly3 } from 'styles/theme';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Center, Disabled, Shadow } from 'styles/GlobalCss'
import { IconButton } from '@mui/material'
import { blink, FlexAround } from 'styles/GlobalStyle';
import { fieldColor, thirdly4, bg } from 'styles/theme';
import { fieldTxtColor } from 'styles/theme';
import { borderRadius, boxSizing, display, fontFamily, fontSize, fontWeight, lineHeight, textAlign } from '@mui/system';
import { lightSecondary } from 'styles/theme';
import { thirdly } from 'styles/theme';
import { isNumber } from 'lodash';
import { sidebar } from 'styles/theme';
import CheckedIcon from 'assets/icons/Checked.svg'
import { hover } from 'styles/theme';

export const WrapEditor = muiStyled(Box)(({ disabled }) => ({
    pointerEvents: disabled && "none",
    opacity: disabled && 0.5,
    width: "100%",
    height: "100%",
    direction: "ltr",
    background: "white",
    borderRadius: 10,
    '.wrapper-editor': {
        background: "white",
        borderRadius: 10
    },
    '.rdw-dropdown-selectedtext': {
        justifyContent: "flex-end"
    },
    '.content-editor': {
        padding: 10,
        boxSizing: "border-box",
        background: "white",
    },
    '.toolbar-editor': {
        borderRadius: 10,
    }
})
)

export const CheckBoxListStyles = muiStyled(Box)(({ disabled }) => ({
    '.checkbox-and-label': {
        display: "flex",
        alignItems: "center"
    }
}))

export const ReadOnlyFieldStyles = muiStyled(Box)(({ disabled }) => ({
    display: "flex",
    flexDirection: "column",
    rowGap: 3,
    '.img': {
        width: 100,
        height: 100
    },
    '.label': {
        color: "#0000004D",
        fontSize: 13.5
    },
    '.value': {
        color: dark
    }
}))

export const AutoCompleteStyles = muiStyled(Box)(({ labelWidth, disabled }) => ({
    '.selected-label': {
        paddingLeft: 5,
        display: "flex",
        alignItems: "center",
        columnGap: 3,
        maxWidth: labelWidth ? labelWidth - 90 : undefined,
        overflow: "hidden",
    },
    '.selected-label-text': {
        minWidth: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },
    '.selected-label-extra': {
        flexShrink: 0,
        whiteSpace: "nowrap"
    },
    '.option-item': {
        columnGap: 8,
        display: "flex",
        alignItems: "center",
        columnGap: 8,
        padding: 10
    },
    '.pulldown-icon': {
        width: 10,
        height: 10,
    },
    '.MuiAutocomplete-popupIndicator': {
        height: 25,
        width: 25
    },
}))


export const OptionStyles = muiStyled(Box)(({ selected, multiple }) => ({
    display: "flex",
    alignItems: "center",
    columnGap: multiple ? 8 : 4,
    padding: "3px 4px",
    backgroundColor: selected && hover,
    ":hover": {
        backgroundColor: hover
    }
}))


export const CheckBoxStyles = muiStyled(Box)(({ disabled }) => ({
    display: "flex",
    columnGap: 3,
    alignItems: "center"
}))

export const TooltipStyles = muiStyled(Box)(({ }) => ({
    '.tooltip-title': {
        textAlign: "start",
        color: dark,
        direction: "ltr",
        width: "100%",
        lineHeight: "23px",
        fontWeight: "normal"
    },
    '.description-tooltip': {
        position: "absolute",
        top: 15,
        right: 15,
        background: "white",
        padding: 20,
        borderRadius: 10,
        fontSize: 19,
        height: 50,
        zIndex: 11,
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
    },
    '.tooltip-corner': {
        background: "white",
        width: 20,
        height: 20,
        position: "absolute",
        top: 79,
        transform: "rotate(45deg)",
        borderBottom: "1px solid #e6e6e6",
        borderLeft: "1px solid #e6e6e6",
    },
}))

export const InputBaseStyles = muiStyled(Box)(({ disabled, border }) => ({
    '.regular': {
        padding: "4px 10px",
        borderRadius: "8px",
        border: "1px solid #00000026"
    },
    '.MuiInputBase-input': {
        position: "relative",
        top: 1
    },
    '.MuiInputAdornment-root': {
        width: 35,
        '.MuiSvgIcon-root': {
            fill: "transparent !important"
        }
    }
}))

export const BadgeStyles = muiStyled(Badge)(({ active }) => ({
    width: 15,
    '.MuiBadge-badge': {
        color: active ? secondary : dark,
        background: active ? lightSecondary : white
    }
}))

export const TextFieldStyles = muiStyled(TextField)(({ showBlurred, disabled, badge }) => ({
    opacity: disabled && 0.6,

    "input": {
        background: badge && badge.bg,
        borderRadius: badge && 7,
        color: badge && badge.color,
        filter: showBlurred && "blur(3.5px)",
        borderColor: badge && `1px solid ${badge.color}`
    },
    '& .MuiInputBase-input.MuiOutlinedInput-input:-webkit-autofill': {
        " -webkit-box-shadow": "none !important",
    },
    '& .MuiFormLabel-root.MuiInputLabel-root': {
        color: fieldTxtColor,
    },
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
        borderRadius: "8px",
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: badge ? "transparent" : fieldColor
    },
    "& .Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
            border: `1px solid ${badge ? "transparent" : "#729DDA"}`,
        }
    },
    "&:hover": {
        "& .MuiOutlinedInput-notchedOutline": {
            border: `1px solid ${badge ? "transparent" : dark}`,
        }
    },
    '.MuiInputAdornment-root': {
        position: "relative",
        left: 15
    }
}))

export const CommentTitle = muiStyled(Box)({
    '.comment-title': {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: dark,
        fontWeight: 700,
        fontSize: 15,
        textAlign: "center"
    },
    '.comment-icon': {
        display: "flex",
        justifyContent: "center"
    }
})

export const WrapComment = muiStyled(({ className, bottom, right, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ bottom, right }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        width: 130,
        height: 130,
        // padding: 10,
        position: "relative",
        bottom: bottom && bottom,
        right: right && right,
        borderRadius: 100,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: white,
        boxShadow: "0px 0px 30px 4px #91BDFA40"
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: white,
        marginRight: "-0.60em !important",
        marginLeft: "-0.60em !important"
    },
    [`& .${tooltipClasses.popper}`]: {
        transform: "translate3d(-826.4px, 587.6px, 0px) !important"
    }
}));

export const WrapTooltip = styled.div`
background:${white};
width:12px;
padding:3px;
border-radius:30px;
${Center};
`

export const Chip = styled.span`
background:${props => props.bg ? props.bg : "transparent"};
border:${props => props.transparent && `1px solid ${props.color}`};
border-radius:${props => props.round ? "30px" : "7px"};
color:${props => props.transparent ? "black" : props.color};
padding:3px 8px;
white-space: nowrap;
display:flex;
column-gap:5px;
justify-conent:center;
align-items:center;
font-size:15px;
height: 20px;

    ${props => props.type == 'icon' && ` 
        height:35px;
        width:35px;
        display:flex;
        justify-content:center;
        align-items:center;
        border-radius:${props => props.round ? "30px" : "10px"};
        padding:3px;
    `}
    ${props => props.type == 'icon' && props.size == "small" && ` 
        height:28px;
        width:28px;
    `}
${Center};
`


export const CustomIconButton = muiStyled(Button)(({ disabled, lightColor, label, size }) => ({
    minWidth: "30px !important",
    borderRadius: "5px !important",
    height: "30px !important",
    width: label ? "auto" : "30px",
    color: label && "black !important",

    '&:hover': {
        background: `${bg} !important`
    },
    background: lightColor && thirdly4,
    border: lightColor && `1px solid ${bg} !important`,
    opacity: disabled && 0.5,
    background: disabled && "white !important",
    width: size == "small" || label ? (label ? "auto" : "30px") : "25px !important",
    height: size == "small" ? "25px !important" : 30,
    ".MuiSvgIcon-root": {
        fill: "transparent !important"
    },
    "rect": {
        fill: "transparent !important"
    }
}))

export const CustomIconButton1 = styled(Button)`
:hover{
background:red !important;
// height:30px !important;
// border-radius:5px !important;
// width:${props => props.label ? "auto" : "30px"} !important;

// .MuiSvgIcon-root{
// fontsize:10px !important;
// }
}
min-width: 30px !important;
border-radius:5px !important;
height:30px !important;
width:${props => props.label ? "auto" : "30px"} !important;
color:${props => props.label && "black !important"};
${props => props.lightColor && `
  background:${thirdly4} !important;
  border:1px solid ${bg} !important;
`}

${props => props.disabled && `
    opacity:0.5 !important;
    background:white !important;
`}

${props => props.size == "small" && `
    width:25px !important;
    height:25px !important;
`}
  
.MuiSvgIcon-root{
fill:transparent !important;
}


    
`

export const WrapGender = styled(FlexAround)`
column-gap: 7px;
`

export const SubTitle = styled.div`
color: rgba(0, 0, 0, 0.50);
font-size: 16px;
`

export const SelectedSideBarItem = styled.div`
width: 5px;
height:100%;
flex-shrink: 0;
background:${props => props.$selected && !props.$hideBorder ? secondary : 'transparent'};
border-radius: 3.5px;
`

export const AudioWrapper = styled.div`
   /* Optional: Style the container holding the audio player */
      max-width: 400px;
    //   margin: auto;
      width: ${props => props.width || '100%'};
      height: ${props => props.height || '100%'};
      background-color: #f0f0f0;
      border-radius: 8px;

    audio::-webkit-media-controls-volume-slider {
      display: none;
    }
    audio::-webkit-media-controls-mute-button {
      display: none;
    }
    audio::-webkit-media-controls-volume-control-container {
      display: none;
    }

`

export const WrapActions = styled.div`
display:flex;
width:100%;
justify-content: space-between;
align-items: center;

`

export const Actions = styled.div`
width: 65px;
`

export const WrapMoreOptions = styled.div`
display:flex;
justify-content:center;
`

export const AudioController = styled.div`
   /* Optional: Style the audio controls */
      display: flex;
      align-items: center;
      justify-content: center;
          width: 100%;
          height:100%;


          audio::-webkit-media-controls-mute-button {
    display: none !important;
    width:0px !important;
}

audio::-webkit-media-controls-volume-slider {
    display: none !important;
    width:0px !important;
}

 
`

export const WrapHeaderUpload = styled.div`
display:flex;
justify-content: space-between !important;
align-items:center;
`

export const WrapIconButton = styled(IconButton)`

width:${props => props.width}px !important;
height:${props => props.height}px !important;
background:${props => props.themeColor?.main} !important;
background:${props => props.$bg && 'white'} !important;

grid-area:${props => props.gridArea && props.gridArea} !important;
${props => props.$disabled && Disabled};
border:${props => props.$border && `1px solid ${props.themeColor?.main}`} !important;
${Center};

.MuiSvgIcon-root{
fill:${props => props.$hideFill && 'transparent !important;'}
}

`

export const IconButton2Styles = muiStyled(IconButton)(({ theme }) => ({
    background: "white",
    border: `1px solid #E3E8F0`,
    color: dark,
    display: "flex",
    columnGap: 7,
    paddingLeft: 8,
    paddingRight: 8,
    alignItems: "center",
    borderRadius: 8,
    height: 35,
    fontSize: 16
}));

export const BpIcon = muiStyled('span')(({ theme }) => ({
    borderRadius: 6,
    width: 17.5,
    height: 17.5,
    border: "1px solid #7E8A9E",
    boxShadow:
        theme.palette.mode === 'dark'
            ? '0 0 0 1px rgb(16 22 26 / 40%)'
            : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : 'white',
    backgroundImage:
        theme.palette.mode === 'dark'
            ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
            : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
    },
    'input:hover ~ &': {
        backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
    },
    'input:disabled ~ &': {
        boxShadow: 'none',
        background:
            theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
    },
}));

export const BpCheckedIcon = muiStyled(BpIcon)({
    backgroundColor: "#2C84FF",
    borderColor: "#2C84FF",
    display: 'block',
    width: 17.5,
    height: 17.5,
    backgroundImage: `url(${CheckedIcon})`, // שימוש במשתנה המיובא
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    content: '""',
    'input:hover ~ &': {
        backgroundColor: '#106ba3',
        cursor: "pointer"
    },
});

export const WrapFab = muiStyled(Fab)`
width:${props => props.size}px !important;
height:${props => props.size}px !important;
font-weight: bold;
font-size:20px !important;
:hover{
      background-color: ${props => gTheme[props.color].main} !important;
      opacity:0.5 !important;
}
`

export const WrapAudio = styled.audio`
width:163px;
height: 30px;

:-webkit-media-controls-play-button {
  background-color: rgba(230, 230, 255, 1);
}
`

export const WrapAudioContent = styled.div`
height:100% !important;
`

export const MuiInput = styled(Input)`
width:100%
`

export const WrapUploadFileButton = styled(Button)`
border: ${props => `1px dashed ${thirdly2} !important`};
padding: 10px;
border-radius: 10px !important;
text-align: center;
background:transparent !important;
color:${gray} !important;
height:${props => props.size == "small" ? "50px" : `${props.boxHeight}px` || "100%"} !important;
width:100% !important;
${Shadow};
`

export const WrapOutlinedInput = muiStyled(InputBase)(({ theme }) => (
    {
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none'
        }
    }
))

export const UploadFileStyles = muiStyled(Box)(({ theme, size }) => ({
    height: "100%",
    '.upload-message': {
        fontSize: size == "small" ? 15 : 20,
        display: "flex",
        columnGap: 10,
        alignItems: "center",
        color: dark
    },
    '.upload-file-message': {
        display: "flex",
        flexDirection: "column",
        rowGap: 10
    },
    '.image-preview': {
        width: 100,
        height: 100
    },
    '.remove-button': {
        cursor: "pointer",
        height: 30,
        transform: 'translateZ(0px)',
        flexShrink: 0,
    },
    '.remove-icon': {
        position: "absolute",
        top: 0
    }
}))

export const Mandatory = styled.span`
color:${mandatory};
`

export const WrapButton1 = muiStyled(LoadingButton)(({ align, direction, width, height, fontsize, theme, $fullWidth, $systemUI }) => (
    {
        gap: "0px",
        width: !$fullWidth && 'auto !important',
        width: width && width,
        width: $fullWidth && '100%',
        borderRadius: $systemUI ? '35px' : "4px",
        display: "flex",
        justifyContent: "space-around",
        fontSize: $systemUI && '18px',
        fontSize: fontsize || 16,
        height: height || 43,
        direction: direction,
        justifyContent: align,


        // ${props => props.disabled && `

        // opacity:0.3;
        // background-color:${props.color?.main} !important;
        // color:${props.color?.contrastText} !important;
        // // background-color:${props.disabledcolor?.main} !important;
        // // color:${props.disabledcolor?.contrastText} !important;
        // `}

        // ${props => props.variant === 'outlined' && `
        // color:black !important;  
        // background-color:${props.disabledcolor?.contrastText} !important;
        // border:1px solid ${props.disabledcolor?.main} !important;

        // `}
        //     }
    }
))

export const WrapButton = muiStyled(LoadingButton)`
gap: 0px;
white-space:nowrap;
min-height:20px;
width:${props => !props.$fullWidth && 'auto !important'};
width:${props => props.$fullWidth && '100% !important'};
border-radius: ${props => props.$systemUI ? '35px' : "7px"};
display: flex !important;
justify-content: space-around !important;
column-gap:5px !important;
min-width: 50px !important;

${props => props.gridArea && `
grid-area:${props.gridArea} !important;    
`}

font-size:${props => props.fontsize ? props.fontsize : '16px'} !important;

height:${props => props.height || "45px"} !important;

width:${props => props.width} !important;

${props => props.size === 'small' &&
        `
    padding: 1px 10px !important;
    height:  auto !important;
    font-size:15px;
    `
    }

direction:${props => props.direction} !important;

${props => props.align && `
justify-content: ${props.align} !important;
`}

${props => props.disabled && `
opacity:0.4;
background-color:${props.disabledcolor?.main} !important;
color:${props.disabledcolor?.contrastText} !important;
`}

${props => props.variant === 'outlined' && `
color:black !important;  
background-color:${props.disabledcolor?.contrastText} !important;
border:1px solid ${props.disabledcolor?.main} !important;
`}

${props => props.variant === 'light' && `
    color:${secondary} !important;  
    background-color:${props.lightColor?.main} !important;
    font-weight:bold;
`}

${props => props.$blink && `
background-position: right center;
background-size: 200% auto;
-webkit-animation: pulse 2s infinite;
animation: pulse512 1.5s infinite;

@keyframes pulse512 {
 0% {
  box-shadow: 0 0 0 0 #e89f61;
 }

 70% {
  box-shadow: 0 0 0 10px rgb(218 103 68 / 0%);
 }

 100% {
  box-shadow: 0 0 0 0 rgb(218 103 68 / 0%);
 }
`}

.btn-text{
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
    text-align: start;
}
`

export const WrapButton2 = muiStyled(Box)(({ lightColor, disabledcolor, align, direction, height, width, gridArea, fontsize, fullWidth, systemUI }) => ({
    width: fullWidth && "100% !important",
    '.dark': {
        ':hover': {
            background: "#133146 !important",
        }
    },
    '.solid2': {
        background: "#FFFFFF !important",
        border: `1px solid ${thirdly2}`,
        borderRadius: "6px !important",
        ':hover': {
            background: "#F5F9FF !important",
        }
    },
    '.danger': {
        color: "#FF0000 !important",
        background: "#FFCBCB !important",
        borderRadius: "8px !important",
        ':hover': {
            background: "#F8B1B1 !important",
        }
    },
    '.solid': {
        ':hover': {
            background: "#E6F0FE !important",
        }
    },
    '.solid-round': {
        borderRadius: "6px !important",
    },
    '.solid-round2': {
        borderRadius: "8px !important",
    },
    '.small': {
        padding: "1px 10px !important",
        height: "28px !important",
        fontSize: "15px !important",
    },
    '.regular': {
        background: `${thirdly2} !important`,
        color: `#2C84FF !important`,
        borderRadius: "8px !important",
        ':hover': {
            background: "#BBD7FF !important",
            color: "#2C84FF !important"
        }
    },
    '.regular2': {
        background: `${thirdly} !important`,
        color: `white !important`,
        borderRadius: "8px !important"
    },
    '.transparent': {
        background: "transparent !important",
        border: `1px solid ${thirdly2}`,
        color: dark
    },
    '.transparent2': {
        background: "transparent !important",
        color: dark
    },
    '.white': {
        background: `${thirdly4} !important`,
        color: `${dark} !important`,
        borderRadius: "8px !important",
        ':hover': {
            background: "#E6F0FE !important"
        }
    },
    '.fullWidth': {
        width: '100% !important'
    },
    '.disabled': {
        opacity: 0.2,
        backgroundColor: `${disabledcolor?.main} !important`,
        color: `${disabledcolor?.contrastText} !important`
    },
    '.outlined': {
        color: "black !important",
        backgroundColor: disabledcolor?.contrastText,
        border: `1px solid ${disabledcolor?.main} !important`,
    },
    '.light': {
        color: `${secondary} !important`,
        backgroundColor: `${lightColor?.main} !important`,
        fontWeight: "bold"
    },
    '.MuiButtonBase-root.MuiButton-root.MuiLoadingButton-root': {
        gap: 0,
        whiteSpace: "nowrap",
        minHeight: 20,
        borderRadius: systemUI ? '35px' : "7px",
        display: "flex",
        justifyContent: "space-around",
        columnGap: "7px",
        minWidth: "50px",
        gridArea: gridArea && `${gridArea}`,
        fontSize: fontsize ? fontsize : `16px`,
        height: `${height || "40px"}`,

        direction: direction,
        justifyContent: align && align,

        width: !fullWidth && 'auto',
        width: width ? (isNumber(width) ? `${width}px !important` : `${width} !important`) : "auto",

    }
}))

export const WrapBlinkButton = muiStyled(WrapButton)({
    animation: `${blink} 2s linear infinite`
})

export const WrapButtonGroup = styled(ButtonGroup)`
border-color:red !important;
${props => props.disabled && `
opacity:0.3;
background-color:${props.disabledcolor?.main} !important;
color:${props.disabledcolor?.contrastText} !important;
`}
`

export const NotificationStyles = muiStyled(Box)(({ size }) => ({
    '.MuiSnackbar-root': {
        left: sidebar + 20,
        transform: "none",
        bottom: 18
    },
    '.MuiPaper-root.MuiAlert-root': {
        background: lightSecondary,
        borderRadius: 15,
        boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 18.2px 0px",
        border: `1px solid ${secondary}`,
        color: dark,
        width: 216,
        display: 'flex',
        flexDirection: 'column-reverse', // מוודאים שהאלמנטים יהיו אחד אחרי השני
        alignItems: 'center',     // למרכז את התוכן
    },
    '.title': {
        fontWeight: "bold",
        fontSize: 18.5,
        color: dark,
        marginBottom: '2px',     // מרווח קטן מתחת לכותרת
    },
    '.description': {
        color: dark,
        fontSize: 17,
        marginBottom: '10px',
        lineHeight: "1.2"
    },
    '.approved-button': {
        width: "100%",            // נותן לכפתור להיות יותר רחב
        display: "flex",
        justifyContent: "end", // ממקם את הכפתור במרכז
    },
    '.wrap-approved-button': {
        marginTop: '10px',       // רווח בין התוכן לכפתור
    }
}));

export const Title = styled.div`
font-size: 23px;
line-height: 39px;
letter-spacing: -0.02em;
text-align: right;
font-weight: bold;
`


export const MuiFormControl = styled(FormControl)`
margin:0 !important;
`

export const Wrap = styled.div`
display: flex;
flex-direction: column;
row-gap: ${props => props.rowGap || "20"}px;
// justify-content: center;
flex-grow: 1;
${props => props.csswrap};
height:100%;

`

export const Error = styled.div`
font-size:15px;
display: flex;
align-items: center;
column-gap: 10px;
margin-top: 5px;
color:${mandatory}
`

export const Error2 = styled.div`
font-size:15px;
display: flex;
align-items: center;
column-gap: 10px;
margin-top: 5px;
color:#AB9603;
`

export const IconError = styled(ErrorOutlineIcon)`
width: 15px !important;
height: 15px !important;
`

export const VisuallyHiddenInput = muiStyled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    background: 'transparent',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

export const WrapField = styled.div`
--padding: 15px; 

// width: 100%;
display: flex;
flex-direction: column;

grid-area:${props => props.gridArea};

${props => props.section && `
background:${white};
padding:var(--padding);
border-radius: 4px;
width: calc(100% - var(--padding)*2);
${Shadow};
`}

.sub-text-field{
margin-top: 5px;
color: ${gray};
font-size: 13px;
}
`

export const WrapFieldContent = styled.div`
display: flex;
flex-direction: column;
row-gap: 10px;
height:100%;
`

export const Label = styled.div`
// color:${dark};
line-height: 21px;
text-align: right;
`

export const Placeholder = styled.div`
color: #b2b9bf;

`

export const AutoCompleteOptions = muiStyled(Paper)(({ theme, $systemUI }) => ({
    backgroundColor: white,
    borderRadius: '2px',
    overflow: 'hidden',
    boxShadow: "2px 2px 18.2px 0px #0000000D",
    "& .MuiAutocomplete-popper.MuiAutocomplete-option[aria-selected='true']": {
        backgroundColor: "red",
    }
}))

export const WrapAutocomplete = muiStyled(Autocomplete)(({ light, shadow, focus, borderRadius, border, theme, minWidth, $systemUI }) => ({
    '& .MuiFormControl-root.MuiTextField-root': {
        minWidth: minWidth || '200px',
    },
    '& .MuiAutocomplete-inputRoot.MuiAutocomplete-input': {
        minWidth: '80px',
    },
    '.MuiAutocomplete-inputRoot': {
        flexWrap: "nowrap !important",
        color: light && ligthGray,
        background: shadow && "white",
        boxShadow: shadow && "0px 0px 20px 0px #CCE1FF",
    },
    '& .MuiAutocomplete-inputRoot': {
        width: "100%",
        position: 'relative',
        fontSize: 16,

    },
    '.MuiOutlinedInput-notchedOutline': {
        border: shadow ? 'none' : (focus && `3px solid #bfd7fa`),
    }
}))

export const BootstrapSelect = muiStyled(Select)(({ theme }) => ({
    'fieldset': {
        borderColor: 'transparent'
    },
    '& .MuiInputBase-input': {
        width: "100%",
        borderRadius: 4,
        position: 'relative',
        background: "#F6F6F6",
        border: '1px solid',
        borderColor: 'transparent',
        fontSize: 16,
        padding: '10px 12px',
        transition: theme.transitions.create([
            'border-color',
            'background-color',
            'box-shadow',
        ]),
        // Use the system font instead of the default Roboto font.
        '&:focus': {
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,

        },
    },
    "&.MuiOutlinedInput-root": {
        "&:hover fieldset": {
            borderColor: "transparent"
        }
    },
}))

export const BootstrapDatePicker = muiStyled(DatePicker)(({ borderRadius, theme, $systemUI }) => ({
    '& .MuiFormLabel-root.MuiInputLabel-root': {
        color: fieldTxtColor
    },
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
        borderRadius: "8px",
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: fieldColor
    },
    '& .MuiInputBase-input': {
        width: "100%",
        position: 'relative',
        fontSize: 16,
        direction: 'rtl',
        textAlign: "end",
        transition: theme.transitions.create([
            'border-color',
            'background-color',
            'box-shadow',
        ]),
        fontFamily: [
            "Calibri", "sans-serif"
        ].join(',')
    }
}))

export const TestAreaStyles = muiStyled(Box)(({ bg, fontSize, textAlign, fullHeight, borderRadius, theme, $systemUI }) => ({
    width: "100%",
    height: "100% !important",
    textarea: {
        padding: 3,
        borderRadius: 8,
        boxSizing: "border-box",
        background: bg ? "white" : "transparent",
        textAlign: textAlign && textAlign,
        width: "100%",
        height: fullHeight && "100% !important",
        textAlign: "right",
        direction: "ltr",
        fontSize: fontSize || 40,
        borderColor: "transparent",
        ":hover": {
            borderColor: "transparent",
        },
        ":focus": {
            borderColor: "transparent",
        },
        fontFamily: [
            "Calibri", "sans-serif"
        ].join(',')
    },
    "textarea:focus": {
        outline: "none",
        boxShadow: "none",
        borderColor: thirdly2 /* or set to your desired color */
    }
}))

export const WrapLabel = styled.div`
font-size:${props => props.fontSize || 14}px;
font-weight:${props => props.bold && 'bold'};
`

export const WrapProgress = styled.div`
display: flex;
justify-content: center;
padding: 10px;
    `

export const WrapFooterBtns = styled.div`
display: flex;
column-gap: 10px;
    `

export const Form = styled.form`
display: flex;
height: 100%;
row-gap: 20px;
flex-direction: column;
    `

export const WrapSideBarItem = styled(Button)`
display:flex;
column-gap: 10px;
display: flex !important;
justify-content: flex-start !important;
padding: 0px !important;
height:40px  !important;
width:100% !important;
box-sizing: border-box !important;
font-weight: ${props => props.$selected ? "bold" : 300} !important;

.item-label-and-icon{
display:flex;
column-gap:5px;
text-align: start;
}

.sub-item-label{
width:105px;
line-height: 14px;
}

.item-content{
display:flex;
align-items:center;
justify-content: space-between;
width: calc(100% - 40px);
}

${props => props.disabled && `
color:${gray} !important;
opacity:0.5 !important;
`}

${props => props.$subItem && `
    color:${props.$selected ? secondary : white} !important;  
`}

.sub-item-icon{
width:30px;
${Center}

path{
 fill:${props => props.$selected ? secondary : white} !important;  
}
}
`

export const WrapListItem = muiStyled(ListItem)(({ theme }) => ({
    width: '100%',
    borderRadius: "35px",
    border: "1px solid #CADDEA",
    height: 50,
    color: "#00000080"
}));

export const Card = styled.div`
border-radius: 25px;
border: 1px #CADDEA;
width:${props => `${props.width}px` || '100%'};
height:${props => `${props.height}px` || '100%'};
background: #FFF;
`
